<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Nicholas and Helen</span></p>
<p class="ded-1"><span>with love.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?384c74f8